import * as ko from 'knockout';
import { Observable } from 'knockout';
import { batchesService } from '../../../api/service.batches';
import { formatDateTime, formatWeight } from '../../../utils/format';

class BatchesDetails {
  readonly title: Observable<string>;

  readonly product = ko.observable<string>();
  readonly weight = ko.observable<string>();
  readonly createdTime = ko.observable<string>();
  readonly invoiceItems = ko.observableArray([]);

  constructor(params: any) {
    this.title = ko.observable('Batch Details');

    this.loadBatch(params.id);
  };

  loadBatch = (batchId: number) => {
    batchesService.getById(batchId)
      .then(result => {
        this.product(result.manufacturedProduct);
        this.weight(formatWeight(result.manufacturedWeight));
        this.createdTime(formatDateTime(result.time));

        const invoiceMaps = result.invoiceItems.map((d: any) => {

          return {
            ...d,
            formattedReceivedTime: formatDateTime(d.receivedTime),
            weightUsed: formatWeight(d.weightUsed),
            unitWeight: formatWeight(d.unitWeight)
          }
        });

        this.invoiceItems(invoiceMaps);
      });
  }

  goto = {
    //orders: (): void => router.goto(routes.webordersDashboard.interpolate({ type: this.viewType() })),
    //invoices: (): void => router.goto(routes.webordersInvoices.interpolate({ id: this.webOrderId() })),
  };

  actions = {

  }
}

export default {
  name: 'bp-batches-details',
  viewModel: BatchesDetails,
  template: require('./details.html')
};
